// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"f8fe67ce870fd4211088","453":"80560ef730ed643d3106","698":"1636292ad59160225d61","739":"75c630bf54dfcb7f1da6"}[chunkId] + ".js";
};